import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaryComponentHelper } from '../../util/bary-component-helper';
import { CommonModule } from '@angular/common';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jhi-bary-card',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MDBBootstrapModulesPro, TranslateDirective, TranslateModule],
  templateUrl: './bary-card.component.html',
  styleUrls: ['./bary-card.component.scss'],
})
export class BaryCardComponent implements OnInit, AfterViewInit {
  @Input() titleKey?: string;
  @Input() titleValue?: any;
  @Input() title?: string;
  @Input() icon?: string;
  @Input() tooltip?: string;
  @Input() borderActive = false;
  @Input() withSwitch = false;
  @Input() checked = false;
  @Input() size: 'md' | 'sm' = 'md';
  @Input() id = BaryComponentHelper.makeId();
  @Input() withCollapse = false;
  @Input() startAsCollapsed = false;
  @Input() disabled = false;
  @Input() disabledMessage = '';

  @Output() switchChangeEvent = new EventEmitter();

  @ViewChild('cardBody') cardBody!: ElementRef;

  _collapseState = false;

  public ngOnInit(): void {
    if (this.withCollapse && this.startAsCollapsed) {
      this._collapseState = true;
    }
  }

  public ngAfterViewInit(): void {
    if (this.cardBody.nativeElement.firstElementChild) this.cardBody.nativeElement.classList.add('card-body');
  }

  public handleSwitchChange($event: boolean): void {
    this.switchChangeEvent.emit($event);
  }

  public handleCollapse(): void {
    if (this.withCollapse) {
      this._collapseState = !this._collapseState;
    }
  }
}
